import { mccs_charge_related_kind } from '@/@types/generated'
import { register } from './enum'

// Labels for mccs_charge_codes.related_kind (see db/migrations/V0308) — what a charge's
// payment_type links to. Used lowercase in the row menu's "View {label}" action, so this
// doesn't fall back to the shared Title Case rule.
const RELATED_KIND_LABELS: Record<mccs_charge_related_kind, string> = {
  [mccs_charge_related_kind.CASE]: 'case',
  [mccs_charge_related_kind.CERTIFICATE]: 'certificate',
  [mccs_charge_related_kind.APPLICATION]: 'application',
}

register<mccs_charge_related_kind>(mccs_charge_related_kind, (v) => {
  if (!v) return '—'
  return RELATED_KIND_LABELS[v]
})
